<template>
  <div>
    <Modal @close="close" @confirm="confirm" :hide-footer="true">
      <template #body>
        <img
          class="top-logo"
          v-if="company.login_top"
          :src="company.login_top"
          :alt="$t(`global.${company.name}`)"
        />
        <div class="loader-area" v-if="isLoading">
          <LoaderFill color="gamma" />
        </div>
        <div v-else class="login-container mt-4">
          <LoginForm @success="confirm" @close="close" />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import LoginForm from "@/components/smart/forms/LoginForm";
import Modal from "@/components/display/Modal";
import store from "@/store";
import useCompany from "@/utils/useCompany";

export default {
  name: "LoginModal",
  components: {
    Modal,
    LoginForm,
  },
  setup(props, { emit }) {
    const isLoading = computed(() => {
      return store.state.settings.status.isLoading;
    });

    const close = () => {
      emit("close");
    };

    const confirm = () => {
      emit("confirm");
    };

    const { company } = useCompany();

    return {
      close,
      confirm,
      company,
      isLoading,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
</style>
